import React, { useContext, useState, useEffect } from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import { useTheme } from '@mui/material/styles';
import { Box, Container, Grid, Typography } from '@mui/material';
import StyledToggleButtonGroup from './MobileOfferToggle.styled';
import styles from './styles';
import { MobileOfferContext } from '../eir-mobile-offer-container/mobile.context';
import RootContext from '../../../util/root.context';

const MobileOfferToggle = ({ onSimoToggle, simOnly = false }) => {
  const theme = useTheme();
  const offersType = ['SIM only - 1 month', 'Bill Pay Phones'];
  const { state, setState } = useContext(MobileOfferContext);
  const { dispatch } = useContext(RootContext);
  const [selectedType, setSelectedType] = useState(simOnly ? offersType[0] : offersType[1]);
  const toggleSimOnly = (event, type) => {
    if (type !== null) {
      setSelectedType(type);
      onSimoToggle(type === 'SIM only - 1 month');
      setState({
        ...state,
        simOnly: type === 'SIM only - 1 month',
      });
      onSimoToggle(type === 'SIM only - 1 month');
    }
    dispatch({ type: 'SET_BILLPAY_TOGGLE', payload: false });
  };

  useEffect(() => {
    setSelectedType(simOnly ? offersType[0] : offersType[1]);
  }, [simOnly]);

  return (
    <Container sx={{ p: 0 }}>
      <Grid container sx={styles(theme).containerToggle}>
        <Box sx={styles(theme).toggleButtonsContainer}>
          <StyledToggleButtonGroup
            size='small'
            value={selectedType}
            exclusive
            selected
            onChange={toggleSimOnly}
            aria-label='mobile_offer_type'
            sx={styles(theme).offerButtons}
            simOnly={simOnly}
          >
            {offersType.map((type, index) => (
              <ToggleButton
                key={index}
                value={type}
                id={`${type}-btn`}
                sx={{
                  p: 1,
                  '&:focus-visible, &.Mui-focusVisible': {
                    outline: `2px solid ${theme.palette.primary.main}`,
                    outlineOffset: 1,
                    borderRadius: 0, // match your button shape
                  },
                }}
                disableRipple
              >
                <Typography variant='subtitle2' component='p' sx={styles(theme).mobileOfferName}>
                  {type.split('-')[0]}
                </Typography>
                {type.split('-')[1] && (
                  <Typography variant='body2' sx={styles(theme).mobileOfferNameOne}>{` - ${
                    type.split('-')[1]
                  }`}</Typography>
                )}
              </ToggleButton>
            ))}
          </StyledToggleButtonGroup>
        </Box>
      </Grid>
    </Container>
  );
};

export default MobileOfferToggle;
